import { render, staticRenderFns } from "./LocationRestrictionSettings.vue?vue&type=template&id=4c11f5fc&scoped=true"
import script from "./LocationRestrictionSettings.vue?vue&type=script&lang=js"
export * from "./LocationRestrictionSettings.vue?vue&type=script&lang=js"
import style0 from "./LocationRestrictionSettings.vue?vue&type=style&index=0&id=4c11f5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11f5fc",
  null
  
)

export default component.exports